<template>
  <div class="dolar-spot">
    <template v-if="header && header.print">
      <a class="title" :href="header.quoteUrl">
        <h3 class="titleModule">DOLAR SPOT</h3>
      </a>
      <div class="head" v-bind:class="header.print.upDownClass">
        <span class="price" v-html="header.print.closingPrice"></span>
        <i class="icon-quote-status"></i>
        <span class="absolute" v-html="header.print.absoluteVariation"></span>
        <span
          class="percentage"
          v-html="header.print.percentageVariation"
        ></span>
      </div>
      <ul class="detail">
        <li>
          <h4 class="labelDetail">PRECIO DE APERTURA</h4>
          <span class="price" v-html="header.print.openingPrice"></span>
        </li>
        <li>
          <h4 class="labelDetail">PRECIO PROMEDIO</h4>
          <span class="price" v-html="header.print.avgPrice"></span>
        </li>
        <li>
          <h4 class="labelDetail">PRECIO MÁXIMO</h4>
          <span class="price" v-html="header.print.maxPrice"></span>
        </li>
        <li>
          <h4 class="labelDetail">PRECIO MÍNIMO</h4>
          <span class="price" v-html="header.print.minPrice"></span>
        </li>
        <li>
          <h4 class="labelDetail">NÚMERO DE TRANSACCIONES</h4>
          <span class="price" v-html="header.print.transactionCount"></span>
        </li>
      </ul>
    </template>
    <div class="dolar-spot-graph">
      <div class="graph">
        <v-chart ref="vgraph" :autoresize="true" :manual-update="true" />
      </div>
      <div class="graph-buttons" v-if="wb">
        <button
          v-for="item in btns"
          v-bind:class="{ active: item.active }"
          :key="item.idx"
          @click="changeScale(item)"
        >
          {{ item.name }}
        </button>
      </div>
    </div>
    <div class="d-flex footer">
      <div class="flex-grow-1">
        <span class="date">
          <strong>Fecha:</strong>
          {{ spotDate }}
        </span>
        <span class="hour">
          <strong>Hora:</strong>
          {{ spotTime }}
        </span>
      </div>
      <div class="btFuente">
        <span>
          <strong>Fuente:</strong>
        </span>
        <a
          href="https://dolar.set-icap.com/"
          target="_blank"
          rel="noopener"
        >
          <span>Set-FX</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ECharts from "vue-echarts";
import VueCompositionAPI from "@vue/composition-api";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import axios from "axios";
import { echartformat } from "./../../../functions/general-functions";
import moment from "moment";

Vue.use(VueCompositionAPI);
echarts.use([LineChart, TooltipComponent, CanvasRenderer]);

export default {
  components: { "v-chart": ECharts },
  props: { withButtons: Boolean },
  created: function () {
    this.toId = null;
    this.graphData = {
      color: ["#4872b8"],
      title: {
        show: false,
      },
      textStyle: {
        fontFamily: '"Montserrat", sans-serif',
      },
      grid: {
        left: "80",
        right: "20",
        bottom: "20",
        top: "20",
      },
      legend: {
        show: false,
      },
      xAxis: {
        type: "category",
        axisTick: {
          alignWithLabel: true,
        },
        splitLine: {
          show: true,
          interval: "auto",
        },
        interval: 5,
        inverse: true,
      },
      series: [
        {
          type: "line",
          showSymbol: true,
          label: {
            show: false,
          },
          encode: {
            seriesName: [1],
            x: 0,
            y: 1,
          },
        },
      ],
    };

    this.url = "/api/quote/spot-historic-h";
    this.params = {
      scale: 1,
      withHeader: true,
    };
    this.style = "currency";
    this.decimals = 2;
  },
  mounted: function () {
    this.wb = this.withButtons ? this.withButtons : false;
    this.initGraph();
    this.updateGraphicData(this.wb);
  },
  methods: {
    initGraph: function () {
      const _self = this;
      this.graphData.yAxis = {
        show: true,
        scale: true,
        axisLabel: {
          formatter: function (vv) {
            var val = echartformat(vv, _self.style, _self.decimals);
            return val;
          },
        },
      };
      this.graphData.tooltip = {
        trigger: "axis",
        formatter: function (params) {
          var p = params[0];
          return (
            p.seriesName +
            "<br/>" +
            echartformat(p.value[1], _self.style, _self.decimals) +
            "<br/>" +
            p.name
          );
        },
      };
    },
    updateGraphicData: function (firstTime) {
      var _self = this;
      axios
        .get(this.url, {
          params: this.params,
        })
        .then(function (d) {
          var data = d.data;
          if (_self.wb && firstTime) {
            _self.btns = data.buttonsData;
          }
          if (
            (!_self.wb || _self.btns.filter((q) => q.active)[0].scale == 1) &&
            (!_self.header ||
              _self.header.print.transactionCount !=
                data.spotHeader.print.transactionCount)
          ) {
            _self.toId = setTimeout(() => {
              _self.updateGraphicData(false);
            }, 120000);
          }
          _self.header = data.spotHeader;
          _self.graphData.dataset = {
            source: data.graphData,
          };
          setTimeout(() => {
            _self.$refs.vgraph.setOption(_self.graphData, true, true);
          }, 500);
        });
    },
    changeScale: function (btn) {
      this.btns = this.btns.map((q) => {
        q.active = false;
        return q;
      });
      btn.active = true;
      this.params.scale = btn.scale;
      if (this.toId) {
        clearTimeout(this.toId);
      }
      this.updateGraphicData(false);
    },
  },
  data: function () {
    return {
      wb: false,
      btns: [],
      header: null,
    };
  },
  computed: {
    spotDate: function () {
      return this.header
        ? moment(this.header.transactionDate).format("DD/MM/YYYY")
        : null;
    },
    spotTime: function () {
      return this.header
        ? moment(this.header.transactionDate).format("hh:mm:ss A")
        : null;
    },
  },
};
</script>
